var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutdoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1d1d1d;stroke-miterlimit:10;stroke-width:1.91px;}")), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "0.55 1.5 22.5 3.41 22.5 6.27 0.55 6.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.59,
    y1: 6.27,
    x2: 20.59,
    y2: 22.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.45,
    y1: 22.5,
    x2: 0.55,
    y2: 22.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.36 12.96 5.32 18.68 5.32 22.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.32 22.5 5.32 18.68 9.14 18.68 9.14 22.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.14,
    y1: 15.82,
    x2: 16.77,
    y2: 15.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.95,
    y1: 22.5,
    x2: 12.95,
    y2: 15.82
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoor);
export default __webpack_public_path__ + "static/media/Outdoor.45f7e4df5e1a6e03cb9c316cc64c8865.svg";
export { ForwardRef as ReactComponent };